import { Component, Host, h, Prop, State, Element, Watch } from '@stencil/core';
import { calculateReadingTime, deepParse, DomService, StringService } from '../../services';
import { ReferencedArticle } from '../types/rcm-articles.types';

@Component({
  tag: 'rcm-editorial-small-feature',
  styleUrl: 'rcm-editorial-small-feature.scss',
  shadow: true,
})
export class RcmEditorialSmallFeature {
  @Element() el: HTMLElement;

  @Prop() articles: string;

  @Prop() bottomMargin: boolean;

  @Prop() isRelatedArticlesColumn: boolean;

  @Prop() marginBigScreen: boolean = false;

  @Prop() parentComponent: string;

  @State() items: ReferencedArticle[];

  @Watch('articles')
  componentWillLoad() {
    try {
      this.items = deepParse(this.articles);
    } catch (e) {
      console.log(e);
    }
  }

  getMetaContent(item: ReferencedArticle) {
    const dateLocale = DomService.getGlobalConfig().locale ?? 'de';

    if (item?.page?.date) {
      return (
        <div class="item__content-meta">
          <span>
            {new Date(item.page.date.split(' ')[0]).toLocaleDateString(dateLocale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
          <span>{item.page.readingTime ? item.page.readingTime : calculateReadingTime(item.page)} min.</span>
        </div>
      );
    }
    return (
      <div class="item__content-meta__icon">
        <rcm-icon icon="arrow-right" width="30px" />
      </div>
    );
  }

  render() {
    const columnsClasses = {
      'margin-bottom': this.bottomMargin,
      'related-articles': this.isRelatedArticlesColumn,
    };

    return (
      <Host>
        <rcm-container class={{ 'margin-big-screen': this.marginBigScreen }}>
          <rcm-columns multipleRows class={columnsClasses}>
            {this.items?.map((item) => (
              <rcm-column spanMedium={6} spanXlarge={3} key={item.page?.link?.fullSlug}>
                <rcm-wrapper-link
                  link={`/${item.page?.link?.fullSlug}`}
                  trackingLinkText={item?.page?.headline}
                  parentComponent={this.parentComponent ?? 'rcm-editorial-small-feature'}
                >
                  <div class="item">
                    {StringService.isValidImageSrc(item.page?.article_img?.filename) && (
                      <div class="item__image">
                        <rcm-image
                          // eslint-disable-next-line camelcase
                          src={`${item.page?.article_img?.filename}/m/400x0/`}
                          fullHeight
                        ></rcm-image>
                      </div>
                    )}
                    <div class="item__content">
                      <rcm-headline class="item__content-headline" level={3} headline={item?.page?.headline} light />
                      <p class="item__content-subline">{item?.page?.text}</p>
                      {this.getMetaContent(item)}
                    </div>
                  </div>
                </rcm-wrapper-link>
              </rcm-column>
            ))}
          </rcm-columns>
        </rcm-container>
      </Host>
    );
  }
}
